import * as React from 'react';
import update from 'immutability-helper';
import {
  Button,
  Form,
  Grid,
  Input,
} from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';

import { LanguageCode } from 'types/tenants/language-code';
import { BaseModal } from 'components/base-modal/component';

export interface Props {
  language?: LanguageCode;
  submit?: (productCode: string, serial: string, expiry: string, lotNumber: string) => void;
}

interface State {
  isModalOpen: boolean;
  productCode: string;
  serialNumber: string;
  expiry: string;
  lotNumber: string;
}

export class ManualInputModal extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.setProductCode = this.setProductCode.bind(this);
    this.setSerialNumber = this.setSerialNumber.bind(this);
    this.setExpiry = this.setExpiry.bind(this);
    this.setLotNumber = this.setLotNumber.bind(this);

    this.isFormValid = this.isFormValid.bind(this);
    this.isEmpty = this.isEmpty.bind(this);

    this.state = {
      isModalOpen: false,
      productCode: '',
      serialNumber: '',
      expiry: '',
      lotNumber: ''
    };
  }
  public render() {
    const i18n = getI18n();

    const modalActionButton = (
      <Button
        className={'modal-confirm submit-manual-entry-button'}
        disabled={!this.isFormValid()}
        onClick={this.handleScan}>
        {i18n.t(translations.Confirm)}
      </Button>
    );

    return (
      <BaseModal
        open={this.state.isModalOpen}
        modalProps={{
          className: 'modal-manual-input',
          size: 'large',
          onClose: this.handleClose,
          trigger: <Button
            icon="keyboard outline"
            labelPosition="right"
            className="no-border-radius manual-entry-button neutral"
            onClick={this.handleOpen}
            content="Manual Input"
          />
        }}
        showHeaderClose={true}
        headerText="Manual Input"
        closeHandler={this.handleClose}
        actionButton={modalActionButton}
      >
        <Form>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Form.Field className="serial-field">
                  <label className="manual-input-label">{i18n.t(translations.SerialNumber)}</label>
                  <Input
                    autoFocus="true"
                    className="manual-input-input"
                    name="manual-input-serial-number"
                    onChange={this.setSerialNumber}
                    onInput={this.setSerialNumber}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </BaseModal>
    );
  }

  private handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      if (this.isFormValid()) {
        this.handleScan();
      }
    }
  }

  private handleOpen = () => {
    this.setState(update(this.state, {
      isModalOpen: { $set: true },
      productCode: { $set: '' },
      serialNumber: { $set: '' },
      expiry: { $set: '' },
      lotNumber: { $set: '' },
    }));

    document.addEventListener('keydown', this.handleKeyDown, false);
  }

  private handleClose = () => {
    document.removeEventListener('keydown', this.handleKeyDown, false);

    this.setState(update(this.state, {
      isModalOpen: { $set: false }
    }));
  }

  private handleScan = () => {
    if (this.props.submit) {
      // this.props.submit('05000456013482', '0123456789', '201201', '00001');
      this.props.submit('', this.state.serialNumber, '', '');
      this.handleClose();
    }
  }

  private setProductCode(event: React.FormEvent<HTMLInputElement>) {
    this.setState(update(this.state, {
      productCode: { $set: event.currentTarget.value }
    }));
  }

  private setSerialNumber(event: React.FormEvent<HTMLInputElement>) {
    this.setState(update(this.state, {
      serialNumber: { $set: event.currentTarget.value }
    }));
  }

  private setExpiry(event: React.FormEvent<HTMLInputElement>) {
    this.setState(update(this.state, {
      expiry: { $set: event.currentTarget.value }
    }));
  }

  private setLotNumber(event: React.FormEvent<HTMLInputElement>) {
    this.setState(update(this.state, {
      lotNumber: { $set: event.currentTarget.value }
    }));
  }

  private isFormValid() {
    return true;
    // !this.isEmpty(this.state.productCode) &&
    //  !this.isEmpty(this.state.serialNumber) &&
    //  !this.isEmpty(this.state.expiry) &&
    //  !this.isEmpty(this.state.lotNumber);
  }

  private isEmpty(value: string) {
    return value === '';
  }
}


// WEBPACK FOOTER //
// ./src/components/manual-input-modal/component.tsx